import _ from 'lodash';
import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import Flex from '../../generic/Flex';
import * as IssuesV2Store from '../../../redux/issuesV2';
import IssueItemLoading from './IssueItem/IssueItemLoading';

/**
 * Renders the entire loading table, using the count
 * to determine the number of loading rows to render.
 */
const IssuesTableLoading: VoidFunctionComponent = () => {
  const count = useSelector(IssuesV2Store.selectors.getCount);
  return (
    <div className="issues-table-body" data-test-id="issues-inbox-loading">
      <Flex direction="column" grow="1">
        {_.times(count, () => IssueItemLoading)}
      </Flex>
    </div>
  );
};

export default IssuesTableLoading;
